
export default {
    Liked : "liked",
    Stupid : "stupid",
    Traveled : "traveled"
}
